export const getDeviceInfo = async () => {
  if (navigator.userAgentData) {
    try {
      const ua = await navigator.userAgentData.getHighEntropyValues([
        "platform",
        "platformVersion",
        "architecture",
        "model",
      ]);

      // Filter fake brands
      const brandInfo =
        navigator.userAgentData.brands?.find(
          (b) => b.brand && b.brand !== "Not:A-Brand"
        ) || {};

      return {
        platform: ua.platform,
        platformVersion: ua.platformVersion,
        architecture: ua.architecture,
        model: ua.model,
        isMobile: navigator.userAgentData.mobile,
        browser: `${brandInfo.brand || "Unknown"} ${brandInfo.version || ""}`.trim(),
        userAgent: navigator.userAgent,
      };
    } catch (error) {
      console.warn("User-Agent Client Hints API failed:", error);
    }
  }

  // fallback
  const userAgent = navigator.userAgent;
  let platform = navigator.platform;
  let isMobile = false;

  if (/Android/.test(userAgent)) {
    platform = "Android";
    isMobile = true;
  } else if (/iPhone|iPad|iPod/.test(userAgent)) {
    platform = "iOS";
    isMobile = /iPhone|iPod/.test(userAgent);
  } else if (/Mac/.test(platform)) {
    platform = "macOS";
  } else if (/Win/.test(platform)) {
    platform = "Windows";
  } else if (/Linux/.test(platform)) {
    platform = "Linux";
  }

  let browser = "Unknown";
  if (/Edg/.test(userAgent)) {
    browser = "Microsoft Edge";
  } else if (/Chrome/.test(userAgent)) {
    browser = "Google Chrome";
  } else if (/Firefox/.test(userAgent)) {
    browser = "Mozilla Firefox";
  } else if (/Safari/.test(userAgent)) {
    browser = "Apple Safari";
  } else if (/Opera|OPR/.test(userAgent)) {
    browser = "Opera";
  }

  return {
    platform,
    platformVersion: "unknown",
    architecture: "unknown",
    model: "unknown",
    isMobile,
    browser,
    userAgent,
  };
};